// Planted defects for the UI's checks, beside what they break (engine/CLAUDE.md). A game's tests switch them on to
// prove a check goes red.

export const UI_FAULTS = {
  /** Icon buttons render without their accessible name (aria-label): axe-core's `button-name` rule must flag it. */
  unlabelledButton: false,
  /** The HUD's per-frame values go through a Preact render instead of the direct writers (hud.ts): gate D2.1's render
   *  counter must go red. */
  hudValueRender: false,
  /** The HUD draws every built-in part whatever `HudStructure.parts` picks (hud.ts): a HUD without the combat stats
   *  shows health, stamina, a weapon and a level again, and the bare-HUD check must go red. */
  hudPartsIgnored: false,
  /** A HUD that picks no parts draws none instead of every one (hud.ts): the action-RPG HUD loses its clusters, and
   *  the "combat HUD renders unchanged" check must go red. */
  hudNoDefaultParts: false,
  /** `setStructure` compares parts one way only (0.4.0's comparison; hud.ts): a duplicate hides a dropped part, and
   *  the redraw check must go red. */
  hudPartsOneWay: false,
  /** World-space UI ignores occlusion (world-ui.ts): an anchor behind a wall stays shown, and the occlusion check
   *  must go red. */
  worldUiIgnoreOcclusion: false,
  /** World-space markers off the screen are hidden instead of clamped at the edge (world-ui.ts): the clamp check
   *  must go red. */
  worldUiNoClamp: false,
  /** The compass strip draws bearings mirrored (east on the west side; compass.ts): the compass test must go red. */
  compassMirrored: false,
};
